import { render } from "./DraftList.vue?vue&type=template&id=6c8473d8&scoped=true"
import script from "./DraftList.vue?vue&type=script&lang=js"
export * from "./DraftList.vue?vue&type=script&lang=js"

import "./DraftList.vue?vue&type=style&index=0&id=6c8473d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8473d8"]])

export default __exports__